import { useState, useEffect } from 'react';
import useAddProductToBasket from './useAddProductToBasket';
import useRemoveProductFromBasket from './useRemoveProductFromBasket';
import useRemoveAllProduct from './useRemoveAllProduct';
import useGetOrders from './useGetOrders';
import { useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';

export const useProductCounter = (productId: number, userId: string | undefined, price: number) => {
  const [productCount, setProductCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const { mutate: addToBasket } = useAddProductToBasket();
  const { mutate: removeFromBasket } = useRemoveProductFromBasket();
  const { mutate: removeAllProduct } = useRemoveAllProduct();
  const { data: cartItems } = useGetOrders(userId || '');
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  useEffect(() => {
    if (cartItems && productId) {
      const count = cartItems.filter(item => item.product?.id === productId).length;
      setProductCount(count);
    }
  }, [cartItems, productId]);

  const handleIncrement = () => {
    if (!userId) {
      navigate('/sign-up');
      return;
    }

    addToBasket(
      {
        createdBy: userId,
        productId: productId,
        price
      },
      {
        onSuccess: () => {
          setProductCount(prev => prev + 1);
          queryClient.invalidateQueries(['useGetOrdersInTheCart']);
          queryClient.invalidateQueries(['useGetOrders']);
        },
        onError: (error) => {
          console.error('Error adding to bag:', error);
        }
      }
    );
  };

  const handleDecrement = () => {
    if (productCount <= 1) {
      removeAllProduct(
        { productId, userId },
        {
          onSuccess: () => {
            setProductCount(0);
            queryClient.invalidateQueries(['useGetOrdersInTheCart']);
            queryClient.invalidateQueries(['useGetOrders']);
          },
          onError: (error) => {
            console.error('Error removing items:', error);
          },
        }
      );
    } else {
      removeFromBasket(
        { productId, userId },
        {
          onSuccess: () => {
            setProductCount(prev => prev - 1);
            queryClient.invalidateQueries(['useGetOrdersInTheCart']);
            queryClient.invalidateQueries(['useGetOrders']);
          }
        }
      );
    }
  };

  const handleAddToBag = () => {
    console.log(cartItems)
    if (!userId) {
      navigate('/sign-in');
      return;
    }

    setIsLoading(true);
    addToBasket(
      {
        createdBy: userId,
        productId: productId,
        price,
      },
      {
        onSuccess: () => {
          setProductCount(prev => prev + 1);
          queryClient.invalidateQueries(['useGetOrdersInTheCart']);
          queryClient.invalidateQueries(['useGetOrders']);
        },
        onError: (error) => {
          console.error('Error adding to bag:', error);
        },
        onSettled: () => {
          setIsLoading(false);
        },
      }
    );
  };

  return {
    productCount,
    isLoading,
    handleIncrement,
    handleDecrement,
    handleAddToBag
  };
}; 